import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BillingData} from '@/types/billing-data';

const defaultBillingDataValues: BillingData = {
  name: '',
  email: '',
  address: {
    street: '',
    streetNumber: '',
    postalCode: '',
    city: '',
    country: '',
    fullAddress: ''
  },
  subscription: null,
  termsOfUseAccepted: false,
  cancellationPolicyAccepted: false
};

interface BillingDataState {
  billingData: BillingData;
}

export const initialState: BillingDataState = {
  billingData: {
    ...defaultBillingDataValues
  }
};

const billingDataSlice = createSlice({
  name: 'billingData',
  initialState,
  reducers: {
    setBillingData(state, action: PayloadAction<Partial<BillingData>>) {
      state.billingData = {
        ...state.billingData,
        ...action.payload
      };
    },
    resetBillingData(state) {
      state.billingData = defaultBillingDataValues;
    },
    resetAddressData(state) {
      state.billingData.address = defaultBillingDataValues.address;
    },
    resetSubscriptionData(state) {
      state.billingData.subscription = null;
      state.billingData.termsOfUseAccepted = false;
      state.billingData.cancellationPolicyAccepted = false;
    }
  }
});

export const {
  setBillingData,
  resetBillingData,
  resetAddressData,
  resetSubscriptionData
} = billingDataSlice.actions;
export default billingDataSlice.reducer;
